import {Component, EventEmitter, Input, OnInit, Output, Pipe, PipeTransform} from '@angular/core';
import {InteractiveMessage} from '../../../../../../shared/models/cerebrum-core';
import {DomSanitizer} from '@angular/platform-browser';
import {FileComponent} from '../file-chat-bubble/file-chat-bubble.component';
import {VideoComponent} from '../video-chat-bubble/video-chat-bubble.component';


@Pipe({name: 'sanitize'})
export class sanitizePipe implements PipeTransform {
    constructor(public sanitization: DomSanitizer) {}
    transform(src: string): any {
        return this.sanitization.bypassSecurityTrustUrl(src)
    }
}

@Component({
    selector: 'app-buttons-chat-bubble',
    templateUrl: './buttons-chat-bubble.component.html',
    styleUrls: ['./buttons-chat-bubble.component.scss'],
    imports: [FileComponent, VideoComponent, sanitizePipe]
})
export class ButtonsChatBubbleComponent implements OnInit {

    activeOption = false;
    @Input() content;

    @Output() sendOption: EventEmitter<any> = new EventEmitter();

    constructor() {
    }

    ngOnInit() {
    }

    sendOptionEmitter(postbackData: string, item: any) {
        const body = this.content?.buttons?.body || undefined;
        const footer = this.content?.buttons?.footer || undefined;

        const message = [body, footer].filter(part => part !== undefined).join(' ').trim();

        const interactiveMessage: InteractiveMessage = {
            title: 'Entity Name',
            replyMessage: message,
            postbackData: postbackData,
            messageDisplay: item.title,
            type: 'button',
            relatedClientMessageId: this.content.clientMessageId
        };

        this.sendOption.emit(interactiveMessage);
        this.activeOption = true;
    }

    getPdfContent() {
        return {
            src: this.content.mediaMetaData.src,
            type: 'application/pdf',
            description: this.getFileName(),
            fileSize: this.content.mediaMetaData.fileSize,
            messageStatus: 'sent'
        };
    }

    getVideoContent() {
        return {
            src: this.content.mediaMetaData.src,
            type: this.content.mediaMetaData.type || 'video/mp4',
            messageStatus: 'sent'
        };
    }

    getMediaType(): string {
        if (!this.content?.mediaMetaData?.src) {
            return '';
        }
        const src = this.content.mediaMetaData.src.toLowerCase();
        if (src.includes('.pdf') || this.content.mediaMetaData.type === 'application/pdf') {
            return 'pdf';
        }
        if (src.includes('.mp4') || src.includes('.mov') || src.includes('.avi') || this.content.mediaMetaData.type?.startsWith('video/')) {
            return 'video';
        }
        if (src.includes('.jpg') || src.includes('.jpeg') || src.includes('.png') || src.includes('.gif') || this.content.mediaMetaData.type?.startsWith('image/')) {
            return 'image';
        }
        return 'image'; // default fallback
    }

    getFileName(): string {
        if (!this.content?.mediaMetaData?.src) {
            return 'Document';
        }
        return this.content.mediaMetaData.description || 'Document';
    }
}
